import fromIcon from "../../assets/icons/departure-time.svg";
import toIcon from "../../assets/icons/arrival-time.svg";
import calendarIcon from "../../assets/icons/calendar.svg";
import timeIcon from "../../assets/icons/time.svg";
import durationIcon from "../../assets/icons/duration.svg";
import personIconDark from "../../assets/icons/person-dark.svg";
import luggageIconDark from "../../assets/icons/luggage-dark.svg";
import ArrivalTime from "../shared/ArrivalTime";

const formatLocation = (longName, shortCode) => {
    if (!longName && !shortCode) return "-";
    if (longName && shortCode) return `${longName} (${shortCode})`;
    return longName || shortCode;
};

const ContractJourneyLegMobile = ({ legs }) => {
    if (!legs || legs.length === 0) {
        return (
            <div className="quote-table-expanded-mobile contract-journey-leg-mobile">
                <div className="quote-table-expanded-mobile__no-data">No flight schedule data available</div>
            </div>
        );
    }

    return (
        <div className="quote-table-expanded-mobile contract-journey-leg-mobile">
            {legs.map((leg, index) => (
                <div key={index} className="quote-table-expanded-mobile__item">
                    <div className="quote-table-expanded-mobile__row">
                        <div className="quote-table-expanded-mobile__label">
                            <span className="quote-table-expanded-mobile__icon-wrapper">
                                <img src={calendarIcon} alt="" className="quote-table-expanded-mobile__icon" />
                            </span>
                            <span>Dep Date:</span>
                        </div>
                        <div className="quote-table-expanded-mobile__value">{leg.formattedDepartureDate || "-"}</div>
                    </div>
                    <div className="quote-table-expanded-mobile__row">
                        <div className="quote-table-expanded-mobile__label">
                            <span className="quote-table-expanded-mobile__icon-wrapper">
                                <img src={timeIcon} alt="" className="quote-table-expanded-mobile__icon" />
                            </span>
                            <span>Dep Time:</span>
                        </div>
                        <div className="quote-table-expanded-mobile__value">
                            {leg.departureTime ? (
                                <>
                                    {leg.departureTime}
                                    {leg.departureTimeZone ? ` ${leg.departureTimeZone}` : ""}
                                </>
                            ) : (
                                "-"
                            )}
                        </div>
                    </div>
                    <div className="quote-table-expanded-mobile__row">
                        <div className="quote-table-expanded-mobile__label">
                            <span className="quote-table-expanded-mobile__icon-wrapper">
                                <img src={fromIcon} alt="" className="quote-table-expanded-mobile__icon" />
                            </span>
                            <span>From:</span>
                        </div>
                        <div className="quote-table-expanded-mobile__value">
                            {formatLocation(leg.fromLong, leg.fromShort)}
                        </div>
                    </div>
                    <div className="quote-table-expanded-mobile__row">
                        <div className="quote-table-expanded-mobile__label">
                            <span className="quote-table-expanded-mobile__icon-wrapper">
                                <img src={durationIcon} alt="" className="quote-table-expanded-mobile__icon" />
                            </span>
                            <span>Duration:</span>
                        </div>
                        <div className="quote-table-expanded-mobile__value">{leg.duration || "-"}</div>
                    </div>
                    <div className="quote-table-expanded-mobile__row">
                        <div className="quote-table-expanded-mobile__label">
                            <span className="quote-table-expanded-mobile__icon-wrapper">
                                <img src={toIcon} alt="" className="quote-table-expanded-mobile__icon" />
                            </span>
                            <span>To:</span>
                        </div>
                        <div className="quote-table-expanded-mobile__value">
                            {formatLocation(leg.toLong, leg.toShort)}
                        </div>
                    </div>
                    <div className="quote-table-expanded-mobile__row">
                        <div className="quote-table-expanded-mobile__label">
                            <span className="quote-table-expanded-mobile__icon-wrapper">
                                <img src={timeIcon} alt="" className="quote-table-expanded-mobile__icon" />
                            </span>
                            <span>Arr Time:</span>
                        </div>
                        <div className="quote-table-expanded-mobile__value">
                            {leg.arrivalTime ? (
                                <ArrivalTime
                                    time={leg.arrivalTime}
                                    timeZone={leg.arrivalTimeZone}
                                    departureDate={leg.departureDate}
                                    arrivalDate={leg.arrivalDate}
                                    departureTime={leg.departureTime}
                                />
                            ) : (
                                "-"
                            )}
                        </div>
                    </div>
                    <div className="quote-table-expanded-mobile__row">
                        <div className="quote-table-expanded-mobile__label">
                            <span className="quote-table-expanded-mobile__icon-wrapper">
                                <img src={personIconDark} alt="" className="quote-table-expanded-mobile__icon" />
                            </span>
                            <span>Pax:</span>
                        </div>
                        <div className="quote-table-expanded-mobile__value">{leg.passengers || "-"}</div>
                    </div>
                    <div className="quote-table-expanded-mobile__row">
                        <div className="quote-table-expanded-mobile__label">
                            <span className="quote-table-expanded-mobile__icon-wrapper">
                                <img src={luggageIconDark} alt="" className="quote-table-expanded-mobile__icon" />
                            </span>
                            <span>Luggage:</span>
                        </div>
                        <div className="quote-table-expanded-mobile__value">
                            {leg.luggage !== undefined && leg.luggage !== null && leg.luggage !== ""
                                ? leg.luggage
                                : leg.luggage === 0
                                  ? leg.luggage
                                  : "-"}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ContractJourneyLegMobile;
